import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class DadosJwtService {

  model = new DadosJwt();

  constructor() { }

  set(jwt: string): void {
    if(jwt) {
      localStorage.setItem('token', jwt);
      let decode = jwtDecode(jwt);
      decode['jwt'] = jwt
      this.model = new DadosJwt(decode);
    }
  }

  get(): DadosJwt {
    if(!this.model.jwt) {
      this.set(localStorage.getItem('token'));
    }
    return this.model;
  }
}
export class DadosJwt {
  jwt: string;
  name: string;
  role: string;
  documento: string;
  razaoSocial: string;
  nome: string;
  tipoUsuario: string;
  statusLogin: string;
  parceiroId: string;
  nbf: number;
  exp: number;
  iat: number;

  constructor(other?: any) {
    if(other) {
      this.jwt = other?.jwt;
      this.name = other?.name;
      this.role = other?.role;
      this.documento = other?.documento;
      this.razaoSocial = other?.razaoSocial;
      this.nome = other?.nome;
      this.tipoUsuario = other?.tipoUsuario;
      this.statusLogin = other?.statusLogin;
      this.parceiroId = other?.parceiroId;
      this.nbf = other?.nbf;
      this.exp = other?.exp;
      this.iat = other?.iat;
    }
  }
}
